<div class="efile-overrides-container">
  @if (hasActiveSubmission() && gridConfig) {

    <!-- Legacy `overrides-grid-list.html` L7–21: refresh, tax year, Filter -->
    <div class="overrides-toolbar">
      <button
        type="button"
        class="overrides-toolbar__icon"
        title="Refresh data"
        aria-label="Refresh data"
        (click)="onToolbarRefresh()">
        <i class="fa fa-refresh" aria-hidden="true"></i>
      </button>
      <div class="overrides-toolbar__filters">
        <label class="overrides-toolbar__year-label">
          <select
            class="overrides-toolbar__year-select"
            name="overridesTaxYear"
            disabled
            aria-label="Tax year">
            @for (opt of taxYearOptions; track $index) {
<option
             
              [value]="opt.value"
              [selected]="isSelectedTaxYearOption(opt)">
              {{ opt.label }}
            </option>
}
          </select>
        </label>
        <button type="button" class="overrides-toolbar__filter-btn" (click)="onToolbarFilter()">
          Filter
        </button>
      </div>
    </div>

    <div
      efileGrid
      #overridesGrid="efileGrid"
      class="gizmo-grid overrides-grid-host"
      [gridConfig]="gridConfig"
      (gridCallback)="onGridCallback($event)"
    ></div>
  
} @else {

    <div class="tab-placeholder">
      <div class="tab-placeholder__hint">
        Select a submission from the Submissions list to load overrides.
      </div>
    </div>
  
}

  
</div>

@if (showOverrideModal) {
<div class="override-modal-overlay" role="dialog" aria-modal="true">
  <div class="override-modal-backdrop" (click)="onOverrideUpdate('cancel')"></div>
  <div class="override-modal-dialog">
    <gtw-efile-override-modal
      [row-data]="overrideRowData"
      [selected-submission]="selectedSubmission"
      (request-grid-update)="onOverrideUpdate($event)"
    ></gtw-efile-override-modal>
  </div>
</div>
}
